import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetReview = createAsyncThunk(
  "getReviewData/getReview",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${endPoint.GetReview}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetReviewSlice = createSlice({
  name: "GetReviewData",
  initialState: {
    GetReviewData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetReview.fulfilled, (state, action) => {
        state.GetReviewData = action.payload;
      })
      .addCase(GetReview.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetReviewSlice.reducer;
